import React, { type ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {

}

const Button: React.FC<ButtonProps> = ({ children, className, ...props }) => {
  return (
    <button className={`font-family-noto-kufi cursor-pointer hover:shadow-lg hover:scale-105 transform transition-all duration-200 ${className}`} {...props}>
       {children}
    </button>
  );
};

export default Button;
